module.exports = {
    title: "Priority",
    crud: {
        create: "Create Priority",
        edit: "Edit Priority",
        view: "View Priority",
    },
    table: {
        title: "Title",
    },
    form: {
        title: "Title",

    },
    validation: {
        required: {
            title: 'Title is required',
        },
        minLength: {
            title: 'title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
